import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from "prop-types";
import axios from "axios";
import Api from "../../assets/js/utils/Api";
import { helper } from "../../assets/js/utils/Element";
import MaterialIcon from "@mdi/react";
import { mdiArrowDown, mdiClose, mdiFolder, mdiEyeOutline } from '@mdi/js';
import Button from "../components/CustomButtons/Button";
import LoaderComponent from "../components/Loader";
import withStyles from "@material-ui/core/styles/withStyles";
import downloadPageStyle from "../../assets/jss/material-kit-pro-react/views/downloadPageStyle.jsx";
import { Link as RouterLink } from 'react-router-dom';
import Link from "@material-ui/core/Link";
import logo from "../../assets/img/logo.png";
import CustomInput from "../components/CustomInput/CustomInput.jsx";
import InputAdornment from "@material-ui/core/InputAdornment";
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import PdfViewModal from "../components/User/PdfViewModal.jsx";

const Download = class extends React.Component {
    constructor(props){
        super(props);
        this.store = this.props.store;
        let recipient = "";
        if(this.props.match.params.hasOwnProperty("recipient")){
            recipient = this.props.match.params.recipient;
        }

        const id = this.props.match.params.id;

        // Phase B: a share session token returned from the magic-link route
        // (/s/{hash}/verify -> /downloads/{hash}?session=...). If none is in the
        // URL, fall back to a previously verified session saved in localStorage
        // so a page reload does not re-prompt for verification.
        let sessionToken = helper.getParam("session");
        if(!sessionToken || sessionToken === "null"){
            sessionToken = null;
        }
        if(sessionToken === null){
            sessionToken = this.readStoredSession(id);
        }

        this.state = {
            response: null,
            id: id,
            recipient: recipient,
            loading: true,
            message: "",
            cancelToken: null,
            error: false,
            errorMessage: null,
            singleFile: true,
            showLogo: false,
            password: "",
            passwordIncorrect: false,
            viewPassword: false,
            validation: {
                password: "",
                isValid: false,
            },
            pdfFileModal: false,
            pdfFile: null,
            // Phase B — recipient verification
            sessionToken: sessionToken,
            needsVerification: false,
            verifyData: null,
            verifyEmail: "",
            verifyMethod: "otp",
            otpCode: "",
            verifyRequested: false,
            verifying: false,
            verifyMessage: null,
            verifyError: false,
        };
        this.cancelToken = null;

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    // Phase B — persist a verified share session per link so a reload keeps access.
    sessionStorageKey(id){
        return "sl_share_session_" + id;
    }
    storeSession(id, token, expiresAt){
        try{
            if(!id || !token){ return; }
            localStorage.setItem(this.sessionStorageKey(id), JSON.stringify({ token: token, expiresAt: expiresAt || null }));
        }catch(e){ }
    }
    readStoredSession(id){
        try{
            if(!id){ return null; }
            const raw = localStorage.getItem(this.sessionStorageKey(id));
            if(!raw){ return null; }
            const parsed = JSON.parse(raw);
            if(!parsed || !parsed.token){ return null; }
            // Note: we intentionally do NOT expire the token on the client.
            // Backend timestamps can be timezone-ambiguous (e.g. a MySQL
            // datetime with no zone parses as browser-local), which would
            // wrongly drop a still-valid token on reload. The server is the
            // authority: if the token is expired/revoked, getTransfer returns
            // needsVerification and loadPreview clears it then.
            return parsed.token;
        }catch(e){ return null; }
    }
    clearStoredSession(id){
        try{
            if(!id){ return; }
            localStorage.removeItem(this.sessionStorageKey(id));
        }catch(e){ }
    }
    componentDidMount(){
        // Persist a session token that arrived via the magic-link return URL.
        const urlSession = helper.getParam("session");
        if(urlSession && urlSession !== "null" && this.state.sessionToken){
            this.storeSession(this.state.id, this.state.sessionToken, null);
        }
        this.loadPreview();
        document.body.classList.add('hide_header_business_account');
        document.body.classList.add('hide_business_background_photo');
    }
    componentDidUpdate(prevProps, prevState){
        const { response } = this.state;
        if(prevState.response === null && response !== null && response.hasOwnProperty('businessUser') && response.businessUser !== null && (response.businessUser.icon_photo_url !== '' && response.businessUser.icon_photo_url !== null)){
            document.body.classList.add('business_account');
            document.body.classList.remove('hide_header_business_account');
            this.setState({
                showLogo: true
            })
        }else if(prevState.response === null && response !== null){
            document.body.classList.remove('hide_header_business_account');
        }

        if(prevState.response === null && response !== null && response.hasOwnProperty('businessUser') && response.businessUser !== null && (response.businessUser.background_photo !== '' && response.businessUser.background_photo !== null)){
            document.body.classList.add('business_background_photo');
            document.body.classList.remove('hide_business_background_photo');
        }else if(prevState.response === null && response !== null){
            document.body.classList.remove('hide_business_background_photo');
        }
    }
    componentWillUnmount(){
        if (this.cancelToken){
            this.cancelToken.cancel('Request Cancelled')
        }
        document.body.classList.remove('business_account');
        document.body.classList.remove('business_background_photo');
    }
    loadPreview(){
        const that = this;
        const source = axios.CancelToken.source();
        this.cancelToken = source;
        that.setState({
            cancelToken: source
        });
        const { id, recipient, sessionToken} = this.state;
        Api.getTransfer(id, recipient, source, false, sessionToken).then(data => {
            // Phase B: verification-required share with no valid session yet.
            if(data && data.needsVerification === true){
                // Any saved session for this link is stale/expired — drop it.
                that.clearStoredSession(id);
                that.setState({
                    loading: false,
                    error: false,
                    needsVerification: true,
                    verifyData: data,
                    sessionToken: null
                });
                return;
            }
            let filesCount = 0;
            if(data.files){
                filesCount = Object.keys(data.files).length;
            }
            that.setState({
                response: data,
                loading: false,
                error: false,
                needsVerification: false,
                singleFile: (filesCount === 1)
            });
        }).catch(err => {
            if(err.message !== "Request Cancelled"){
                this.setState({
                    loading: false,
                    error: true,
                    errorMessage: err.message
                });
            }
        });
    }
    renderFile(item, key){
        const { classes } = this.props;
        const { singleFile, response } = this.state;
        if(item.type === "file"){
            return <li key={key}>
                <div className="file">
                    <div className="file-header">
                        <div className={classes.poptip}>
                            <h6 className="file-title">{item.file.name}</h6>
                        </div>
                        <div className="file-details">
                            <span className="file-detail">{item.file.size}</span>
                            <span className="file-detail1">{item.file.extension}</span>
                            {
                                singleFile ?
                                    <></>
                                : !singleFile && response.pdf_tracking === 1 && helper.isPdfDocument(item.file) ?
                                    <Button className={"downloadIcon"} size="sm" color="custom" justIcon onClick={() => this.onPdfFileModal(true, item.file)}>
                                        <MaterialIcon path={mdiEyeOutline} className="MuiSvgIcon-root" />
                                    </Button>
                                :
                                    <Link href={this.withSession(item.file.downloadLink)} className={"downloadIcon"} target="_blank">
                                        <Button color="custom" justIcon size="sm">
                                            <MaterialIcon path={mdiArrowDown} className="MuiSvgIcon-root" />
                                        </Button>
                                    </Link>
                            }
                        </div>
                    </div>
                </div>
            </li>;
        }
        let sizeInMBs = (item.size/(1024*1024));
        return <li key={key}>
            <div className="file">
                <div className="file-header">
                    <div className={classes.poptip}>
                        <h6 className="file-title">{item.name}</h6>
                    </div>
                    <div className="file-details">
                        <span className="file-detail">
                            <MaterialIcon path={mdiFolder} className="MuiSvgIcon-root"/>
                            <span className="folder-detail">Folder</span>
                        </span>
                        <span className="filedetail1">{item.files.length} items</span>
                        {
                            singleFile || sizeInMBs >= 500 ?
                                <></>
                            :
                                <Link href={this.withSession(item.downloadLink)} className={"downloadIcon"} target="_blank">
                                    <Button color="custom" justIcon size="sm">
                                        <MaterialIcon path={mdiArrowDown} className="MuiSvgIcon-root" />
                                    </Button>
                                </Link>
                        }
                    </div>
                </div>
            </div>
        </li>;
    }
    renderFiles(){
        const { response } = this.state;
        if(response === null){
            return null;
        }
        const { classes } = this.props;
        if(response.files.length > 10){
            return <li>
                <div className="file">
                    <div className="file-header">
                        <div className={classes.poptip}>
                            <h6 className="file-title">{response.files.length} files</h6>
                        </div>
                        <div className="file-details">
                            <span className="file-detail1">{helper.getFormatedSize(response.totalSize)}</span>
                        </div>
                    </div>
                </div>
            </li>
        }
        let renderFiles = [];
        for(var key in response.files){
            const item = response.files[key];
            renderFiles.push(this.renderFile(item, key));
        }
        // response.files.map((file, key) => {
        //     renderFiles.push(this.renderFile(file, key));
        //     return null;
        // });
        return renderFiles;
    }
    handleChange(e, name){
        let state = {};
        let value = e.target.value;
        state[name] = value;
        this.setState(state);
    }
    validateForm(){
        let validation = {
            password: 'success',
            isValid: true
        };

        const values = this.state;
        
        if(values.password.length <= 0){
            validation.password = "error";
            validation.isValid = false;
        }
        this.setState({validation: validation});
        return validation.isValid;
    }
    handleSubmit(e){
        e.preventDefault();
        const isValid = this.validateForm();
        if(!isValid){
            return;
        }

        const that = this;
        const source = axios.CancelToken.source();
        this.setState({cancelToken: source, loading: true});
        
        const { id, recipient, password} = this.state;

        let requestData = {
            recipient: recipient,
            password: password
        };
        Api.previewPassword(id, requestData, source).then(data => {
            if(data.passwordIncorrect){
                that.setState({
                    passwordIncorrect: true,
                    loading: false
                })
                return;
            }
            
            let filesCount = Object.keys(data.files).length;
            that.setState({
                response: data,
                loading: false,
                error: false,
                singleFile: (filesCount === 1),
                passwordIncorrect: false
            });
        }).catch(err => {
            if(err && err.message !== "Request Cancelled"){
                this.setState({
                    loading: false,
                    error: true,
                    errorMessage: err.message
                });
            }  
        });
    }
    handleAdUrl(e, bannerUrl){
        e.preventDefault();
        if(bannerUrl){
            window.open(bannerUrl, '_blank');
        }
    }
    onViewPassword(){
        this.setState({
            viewPassword: !this.state.viewPassword
        })
    }
    onPdfFileModal(status = false, pdfFile = null){
        let state = {};
        state['pdfFileModal'] = status;
        state['pdfFile'] = pdfFile;

        this.setState(state)
    }
    // Append the share-session token to a download URL for verification-required shares.
    withSession(url){
        const { sessionToken } = this.state;
        if(!url || !sessionToken){
            return url;
        }
        return url + (url.indexOf("?") === -1 ? "?" : "&") + "sessionToken=" + encodeURIComponent(sessionToken);
    }
    onVerifyMethod(method){
        this.setState({ verifyMethod: method, verifyMessage: null, verifyError: false });
    }
    // Step 1 — request an OTP code or a magic link for the entered email.
    requestVerification(e){
        if(e){ e.preventDefault(); }
        const { verifyEmail, verifyMethod, verifyData } = this.state;
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if(!emailRegex.test(verifyEmail)){
            this.setState({ verifyError: true, verifyMessage: "Please enter a valid email address." });
            return;
        }
        const hash = (verifyData && verifyData.hash) ? verifyData.hash : this.state.id;
        const source = axios.CancelToken.source();
        this.setState({ verifying: true, verifyError: false, verifyMessage: null, cancelToken: source });
        Api.requestShareVerification(hash, { email: verifyEmail, method: verifyMethod }, source).then(data => {
            this.setState({
                verifying: false,
                verifyRequested: true,
                verifyMessage: verifyMethod === "magic"
                    ? "If that email is a permitted recipient, we've sent a sign-in link. Open it to continue."
                    : "If that email is a permitted recipient, we've sent a 6-digit code. Enter it below."
            });
        }).catch(err => {
            if(err && err.message !== "Request Cancelled"){
                // Backend responds generically; still surface a soft message on failure.
                this.setState({ verifying: false, verifyError: true, verifyMessage: (err && err.message) ? err.message : "Could not send the code. Please try again." });
            }
        });
    }
    // Step 2 (OTP) — verify the code and, on success, reload the preview with the session.
    submitOtp(e){
        if(e){ e.preventDefault(); }
        const { verifyEmail, otpCode, verifyData } = this.state;
        if(!otpCode || otpCode.trim().length <= 0){
            this.setState({ verifyError: true, verifyMessage: "Enter the code from your email." });
            return;
        }
        const hash = (verifyData && verifyData.hash) ? verifyData.hash : this.state.id;
        const source = axios.CancelToken.source();
        this.setState({ verifying: true, verifyError: false, verifyMessage: null, cancelToken: source });
        Api.verifyShare(hash, { email: verifyEmail, code: otpCode.trim() }, source).then(data => {
            if(data && data.verified === true && data.sessionToken){
                // Save the verified session so a reload does not re-prompt.
                this.storeSession(this.state.id, data.sessionToken, data.expiresAt || null);
                this.setState({
                    verifying: false,
                    needsVerification: false,
                    sessionToken: data.sessionToken,
                    otpCode: "",
                    verifyMessage: null
                }, () => this.loadPreview());
            }else{
                this.setState({ verifying: false, verifyError: true, verifyMessage: (data && data.message) ? data.message : "That code is incorrect or expired." });
            }
        }).catch(err => {
            if(err && err.message !== "Request Cancelled"){
                this.setState({ verifying: false, verifyError: true, verifyMessage: (err && err.message) ? err.message : "That code is incorrect or expired." });
            }
        });
    }
    renderVerification(){
        const { classes } = this.props;
        const { verifyData, verifyEmail, verifyMethod, otpCode, verifyRequested, verifying, verifyMessage, verifyError } = this.state;
        const permittedEmails = (verifyData && verifyData.permittedEmails) ? verifyData.permittedEmails : [];
        const methods = (verifyData && verifyData.methods) ? verifyData.methods : ["otp", "magic"];
        return (
            <div className={classes.transferForm+" password-form share-verify-form"}>
                <div className={classes.transferContent}>
                    <RouterLink to={'/'} className={"closeIcon"}>
                        <MaterialIcon path={mdiClose} className="MuiSvgIcon-root" />
                    </RouterLink>
                </div>
                <div className={classes.downloaderHeading+" downloader-heading"}>
                    <h2>Verify your email to access these file(s)</h2>
                    {
                        permittedEmails.length > 0 ?
                            <p>This share is limited to: {permittedEmails.join(", ")}</p>
                        :
                            <p>Enter your email to receive a verification {verifyMethod === "magic" ? "link" : "code"}.</p>
                    }
                </div>
                {
                    verifyMessage ?
                        <div className={(verifyError ? "passwordCheck-notValid-customizable" : "passwordCheck-valid-customizable")}>
                            <span aria-hidden="true" className="validation-error-symbol check-lowerletter">{verifyError ? "✖" : "✔"}</span>
                            <span className="checkPasswordText-lowerletter">{verifyMessage}</span>
                        </div>
                    :
                        <></>
                }
                {
                    methods.length > 1 ?
                        <div className={classes.verifyMethods+" verify-methods"}>
                            <Button color={verifyMethod === "otp" ? "custom" : "white"} size="sm" type="button" onClick={() => this.onVerifyMethod("otp")}>Email a code</Button>
                            <Button color={verifyMethod === "magic" ? "custom" : "white"} size="sm" type="button" onClick={() => this.onVerifyMethod("magic")}>Email a link</Button>
                        </div>
                    :
                        <></>
                }
                <form onSubmit={(e) => this.requestVerification(e)} className={"form"}>
                    <CustomInput
                        formControlProps={{ fullWidth: true, className: classes.customFormControlClasses }}
                        labelText="Your email"
                        id="verify-email"
                        inputProps={{
                            type: "email",
                            name: "verifyEmail",
                            value: verifyEmail,
                            onChange: (e) => this.handleChange(e, 'verifyEmail'),
                            autoComplete: 'email'
                        }}
                    />
                    <div className={classes.formFooter}>
                        <Button color="custom" className={"form-button"} type="submit" disabled={verifying}>
                            {
                                verifying && !verifyRequested ?
                                    <LoaderComponent color="white" />
                                :
                                    (verifyRequested ? "Resend" : (verifyMethod === "magic" ? "Send link" : "Send code"))
                            }
                        </Button>
                    </div>
                </form>
                {
                    verifyRequested && verifyMethod === "otp" ?
                        <form onSubmit={(e) => this.submitOtp(e)} className={"form"}>
                            <CustomInput
                                formControlProps={{ fullWidth: true, className: classes.customFormControlClasses }}
                                labelText="Verification code"
                                id="verify-code"
                                inputProps={{
                                    type: "text",
                                    name: "otpCode",
                                    value: otpCode,
                                    onChange: (e) => this.handleChange(e, 'otpCode'),
                                    autoComplete: 'one-time-code'
                                }}
                            />
                            <div className={classes.formFooter}>
                                <Button color="custom" className={"form-button"} type="submit" disabled={verifying}>
                                    {
                                        verifying ?
                                            <LoaderComponent color="white" />
                                        :
                                            "Verify"
                                    }
                                </Button>
                            </div>
                        </form>
                    :
                        <></>
                }
            </div>
        );
    }
    render() {
        const { classes } = this.props;
        const { response, loading, message, error, errorMessage, showLogo, validation, passwordIncorrect, viewPassword,
            pdfFileModal, pdfFile, needsVerification
         } = this.state;

        let htmlClass = 'layout_page_downloads';
        if(response && response.hasOwnProperty('businessUser') && response.businessUser !== null && response.businessUser.download_style === "boxed"){
            htmlClass += ' boxed_style';
        }

        const { user } = this.store.getState();
        
        return (
            <>
                <div className={classes.landingPageContainer}>
                    {
                        response && response.hasOwnProperty('businessUser') && response.businessUser !== null && (response.businessUser.profile_photo_url !== '' && response.businessUser.profile_photo_url !== null) ?
                            <div className={classes.businessLeagelHeader+" business-legal-header"}>
                                <img className={"business-logo"} src={response.businessUser.profile_photo_url} alt="company logo" />
                            </div>
                        :
                            <></>
                    }
                    <div className={classes.downloadPageContent}>
                        {
                            response && response.hasOwnProperty('businessUserAds') && response.businessUserAds !== null && ( response.businessUserAds.header_banner_photo !== '' && response.businessUserAds.header_banner_photo !== null ) ?
                                <div className={"downloadBottomAd downloadHeaderAd"}>
                                    <Link href="/" onClick={(e) => this.handleAdUrl(e, response.businessUserAds.header_banner_url)}>
                                        <img className="banner-image" src={response.businessUserAds.header_banner_photo} alt='ad-banner' />
                                    </Link>
                                </div>
                            :
                                <></>
                        }
                        <div className={"downloadTopColumns"}>
                            <div className={"leftAdColumn"}>
                                {
                                    response && response.hasOwnProperty('businessUserAds') && response.businessUserAds !== null && ( response.businessUserAds.left_banner_photo !== '' && response.businessUserAds.left_banner_photo !== null ) ?
                                        <Link href="/" onClick={(e) => this.handleAdUrl(e, response.businessUserAds.left_banner_url)}>
                                            <img className="banner-image" src={response.businessUserAds.left_banner_photo} alt='ad-banner' />
                                        </Link>
                                    :
                                        <></>
                                }
                            </div>
                            {
                                error === false && needsVerification === true ?
                                    this.renderVerification()
                                : error === false && response !== null && response.hasPassword === true ?
                                    <div className={classes.transferForm+" password-form"}>
                                        <div className={classes.transferContent}>
                                            <RouterLink to={'/'} className={"closeIcon"}>
                                                <MaterialIcon path={mdiClose} className="MuiSvgIcon-root" />
                                            </RouterLink>
                                        </div>
                                        <div className={classes.downloaderHeading+" downloader-heading"}>
                                            <h2>Please enter password to access file(s)</h2>
                                        </div>
                                        <form onSubmit={this.handleSubmit} className={"form"}>
                                            {
                                                passwordIncorrect === true ?
                                                    <div className={"passwordCheck-notValid-customizable"}>
                                                        <span aria-hidden="true" className="validation-error-symbol check-lowerletter">&#x2716;</span>
                                                        <span className="checkPasswordText-lowerletter">Password is Incorrect</span>
                                                    </div>
                                                :
                                                <></>
                                            }
                                            <CustomInput
                                                formControlProps={{
                                                    fullWidth: true,
                                                    className: classes.customFormControlClasses
                                                }}
                                                success={validation.password === "success"}
                                                error={validation.password === "error" || passwordIncorrect}
                                                id="input-password"
                                                labelText="Password"
                                                passwordInput={viewPassword ? false : true}
                                                inputProps={{
                                                    onChange: (e) => this.handleChange(e, 'password'),
                                                    name: "password",
                                                    value: this.state.password,
                                                    type: "text",
                                                    autoComplete: 'off',
                                                    endAdornment: (
                                                        <InputAdornment 
                                                            className={classes.inputAdornment+' viewPasswordIcon'} 
                                                            onClick={() => this.onViewPassword() }
                                                            position='end'
                                                        >
                                                            {
                                                                this.state.password ?
                                                                    viewPassword ?
                                                                        <VisibilityOffIcon className={classes.inputAdornmentIcon}/>
                                                                    :
                                                                        <VisibilityIcon className={classes.inputAdornmentIcon}/>
                                                                :
                                                                    <></>
                                                            }
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                            <div className={classes.formFooter}>
                                                <Button color="custom" className={"form-button"} type="submit" disabled={loading ? true: false}>
                                                    {
                                                        loading ?
                                                            <LoaderComponent color="white" />
                                                        :
                                                            "Submit"
                                                    }
                                                </Button>
                                            </div>
                                        </form>
                                    </div>
                                :
                                    <div className={classes.transferForm}>
                                        <div className={classes.transferContent}>
                                            <RouterLink to={'/'} className={"closeIcon"}>
                                                Close
                                                <MaterialIcon path={mdiClose} className="MuiSvgIcon-root" />
                                            </RouterLink>
                                            <div className={classes.downloaderHeading+" downloader-heading "+(error?classes.errorHeading:"")}>
                                                <div className="arrowIcon">
                                                    <MaterialIcon path={mdiArrowDown} className="MuiSvgIcon-root" />
                                                </div>
                                                {
                                                    error === true ?
                                                        <p className={classes.processingWarning}>{errorMessage}</p>
                                                    :
                                                        <h2>Ready when you are</h2>
                                                }
                                                {
                                                    response !== null ?
                                                        <>
                                                            {
                                                                response.deletion_time === "Unlimited" || response.expire_at === null ?
                                                                    <></>
                                                                :
                                                                    <p>Files will be deleted in {response.deletion_time}</p>
                                                            }
                                                            
                                                            <div className="downloader-message">
                                                                <div dangerouslySetInnerHTML={{__html: response.message}}></div>
                                                            </div>
                                                        </>
                                                    :
                                                    <></>
                                                }
                                            </div>
                                            {
                                                response !== null ?
                                                    <ul className={classes.filesList}>
                                                        {this.renderFiles()}
                                                    </ul>
                                                :
                                                <></>
                                            }
                                        </div>
                                        {
                                            error === false ?
                                                <div className={classes.transferFooter+" "+(showLogo ? 'footer-with-logo': '')}>
                                                    {
                                                        response !== null ?
                                                            response.state === "uploaded" ?
                                                                <p className={classes.processingWarning}>Please wait we are processing your files. It may take several minutes depending on total size of files.</p>
                                                            :
                                                                response.files.length <= 1 && response.pdf_tracking === 1 && helper.isPdfDocument(response.files[0].file) ?
                                                                    <Button color="custom" className="transfer-button" type="button" onClick={() => this.onPdfFileModal(true, response.files[0].file)}>
                                                                        Preview
                                                                    </Button>
                                                                :
                                                                    <a href={this.withSession(response.downloadUrl)} className="transfer-button">
                                                                        Download
                                                                    </a>
                                                        :
                                                            loading ?
                                                                <Button color="custom" disabled className="transfer-button" type="button">
                                                                    <LoaderComponent color="white" />
                                                                </Button>
                                                            :
                                                                message
                                                    }
                                                    {
                                                        showLogo ?
                                                            <img src={logo} alt={"Sendlinx"} className='footer-logo' />
                                                        :
                                                            <></>
                                                    }
                                                </div>
                                            :
                                            <></>
                                        }
                                        {
                                            response && response.hasOwnProperty('businessUser') && response.businessUser !== null && response.businessUser.about !== null ?
                                                <div className={classes.aboutBusiness} dangerouslySetInnerHTML={{__html: response.businessUser.about.replace(/href/g, "target='_blank' href")}}></div>
                                            :
                                            <></>
                                        }
                                    </div>
                            }
                            <div className={"rightAdColumn"}>
                                {
                                    response && response.hasOwnProperty('businessUserAds') && response.businessUserAds !== null && ( response.businessUserAds.right_banner_photo !== '' && response.businessUserAds.right_banner_photo !== null ) ?
                                        <Link href="/" onClick={(e) => this.handleAdUrl(e, response.businessUserAds.right_banner_url)}>
                                            <img className="banner-image" src={response.businessUserAds.right_banner_photo} alt='ad-banner' />
                                        </Link>
                                    :
                                        <></>
                                }
                            </div>
                        </div>
                        {
                            response && response.hasOwnProperty('businessUserAds') && response.businessUserAds !== null && ( response.businessUserAds.bottom_banner_photo !== '' && response.businessUserAds.bottom_banner_photo !== null ) ?
                                <div className={"downloadBottomAd"}>
                                    <Link href="/" onClick={(e) => this.handleAdUrl(e, response.businessUserAds.bottom_banner_url)}>
                                        <img className="banner-image" src={response.businessUserAds.bottom_banner_photo} alt='ad-banner' />
                                    </Link>
                                </div>
                            :
                                <></>
                        }
                    </div>
                    <Helmet 
                        htmlAttributes={{
                            class: htmlClass,
                            title: process.env.REACT_APP_TITLE
                        }}
                    />
                </div>
                {
                    response && response.hasOwnProperty('businessUser') && response.businessUser !== null && (response.businessUser.background_photo !== '' && response.businessUser.background_photo !== null ) && user.theme === "standard" ?
                        <div className="business_bg_slider">
                            <div className={classes.backgroundSlider+" business-bg-slider"}>
                                <div className="background-image" style={{backgroundImage: 'url('+response.businessUser.background_photo+')'}}></div>
                            </div>
                        </div>
                    :
                        <></>
                }
                {
                    pdfFileModal ?
                        <PdfViewModal 
                            store={this.store}
                            open={pdfFileModal} 
                            file={pdfFile}
                            onClose={() => this.onPdfFileModal(false)}
                            trackPdf={true}
                            ownerId={response.owner_id}
                        />
                    :
                        <></>
                }
            </>
        )
    }
}

Download.propTypes = {
    classes: PropTypes.object
};

export default withStyles(downloadPageStyle)(Download);
